import { render, staticRenderFns } from "./ArticleCategories.vue?vue&type=template&id=57866cc7&scoped=true&"
import script from "./ArticleCategories.vue?vue&type=script&lang=js&"
export * from "./ArticleCategories.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCategories.vue?vue&type=style&index=0&id=57866cc7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57866cc7",
  null
  
)

export default component.exports